import './App.css';
import './assets/css/style.css';
import RouteHandler from './utilities/RouteHandler';

function App() {
  return <RouteHandler />
}

export default App;
